import React, { useEffect, useMemo } from 'react'
import useLineService from './service'
import Styles from './index.module.scss'
import { useUpdateEffect } from 'ahooks'
import { Modal } from 'antd-mobile'

export default function Line() {

    const { lines, loadingLine, runGetLine, runUpdateLine } = useLineService()

    useEffect(() => {
        runGetLine()
    }, [])

    const selectJsx = useMemo(() => {
        return lines.map((l,i) => {
            return <div key={i} className={`${Styles.part}`} onClick={() => runUpdateLine(l)}>
                {l.lineName}
            </div>
        })
    },[lines])

    useUpdateEffect(() => {
        Modal.show({
            content: selectJsx,
            closeOnMaskClick: false,
        })
    }, [lines])

    return (
        <div className={`${Styles.line}`}>
            <div className={`${Styles.choose}`}>请先选择公司级条线</div>
        </div>
    )
}
